const StatusIrregularidade = {
    NAO_FISCALIZADO: 1,
    CONFORME: 2,
    NAO_CONFORME: 3,
    INCONFORMIDADE_CORRIGIDA: 4,
    IRREGULARIDADE_NAO_CORRIGIDA: 5,
    CORRECAO_EM_ANALISE: 6,
    IRREGULARIDADE_CORRIGIDA: 7
};
  
export default StatusIrregularidade;